import React, { useEffect, useState } from 'react';
import { StatusCodes } from 'http-status-codes';
import { useHistory, useParams } from 'react-router-dom';

import TitleComponent from '~/src/components/common/forms/Title/TitleComponent';
import SecondaryNavigation from '~/src/components/common/navigation/SecondaryNavigation';
import WhitePad from '~/src/components/common/WhitePad/WhitePad';
import InventoryApi from '~/src/services/api/InventoryApi';
import PalletDescription from './components/PalletDescription';
import { PalletDescriptionWithOrder } from './PalletDescriptions';
import PalletDescriptionRowShort from './components/PalletDescriptionRowShort';
import PalletDescriptionsApi from '~/src/services/api/PalletDescriptionsApi';
import Loader from '~/src/components/common/Loader';

export default function PalletNumbering(): JSX.Element {
  const { id, consolidation } = useParams();
  const history = useHistory();
  const [itemData, setItemData] = useState<PalletDescriptionWithOrder | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [loadingError, setLoadingError] = useState<string | null>(null);

  const getItem = async (): Promise<void> => {
    setLoading(true);
    const result = await PalletDescriptionsApi.getPalleDescription(id, false);
    if (result.status === StatusCodes.OK || StatusCodes.NO_CONTENT) {
      setItemData(result.data);
      if (result.data?.palletData?.length === 0) {
        setLoadingError('No data');
      }
    } else {
      setLoadingError('Error loading data');
    }
    setLoading(false);
  };

  useEffect(() => {
    getItem();
  }, []);

  return (
    <WhitePad isFluid>
      <SecondaryNavigation isConsolidation={consolidation} />

      <TitleComponent
        title={`Pallet Numbering #${itemData?.order?.orderNumber}`}
        onLeftHandler={(): void => {
          history.push('/orders-list');
        }}
      />

      <p>{itemData?.order?.customer?.name}</p>
      <p>{itemData?.order?.orderNumber}</p>

      {loading ? (
        <Loader />
      ) : loadingError ? (
        <div>{loadingError}</div>
      ) : (
        <div>
          {itemData?.palletData.map((locationWithQuantities, index: number) => {
            return <PalletDescriptionRowShort key={index} item={locationWithQuantities} index={index} />;
          })}
        </div>
      )}
    </WhitePad>
  );
}
